import { render, staticRenderFns } from "./ProofreadingFishConfirmDialog.vue?vue&type=template&id=7c47bbce&scoped=true"
import script from "./ProofreadingFishConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingFishConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingFishConfirmDialog.vue?vue&type=style&index=0&id=7c47bbce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47bbce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c47bbce')) {
      api.createRecord('7c47bbce', component.options)
    } else {
      api.reload('7c47bbce', component.options)
    }
    module.hot.accept("./ProofreadingFishConfirmDialog.vue?vue&type=template&id=7c47bbce&scoped=true", function () {
      api.rerender('7c47bbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingFishConfirmDialog.vue"
export default component.exports